// import components below
import PropTypes from 'prop-types';
import PageHeaderUI from 'components/UI/PageHeaderUI';

// main component
const PageHeader = ({ active }) => {
  return (
    <div className='accountingHeader'>
      <PageHeaderUI>
        <h4>Accounting Module</h4>
        <p>Dashboard / {active}</p>
      </PageHeaderUI>
    </div>
  );
};

PageHeader.defaultProps = {
  active: '',
};

PageHeader.propTypes = {
  active: PropTypes.string,
};

export default PageHeader;
